import { render, staticRenderFns } from "./LegacyProductTable.vue?vue&type=template&id=4459fbb1&"
import script from "./LegacyProductTable.vue?vue&type=script&lang=ts&"
export * from "./LegacyProductTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports